/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_HiddenInputs */

const en_entity_hidden = /** @type {(inputs: Entity_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

const de_entity_hidden = /** @type {(inputs: Entity_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versteckt`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Entity_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_hidden = /** @type {((inputs?: Entity_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_hidden(inputs)
	return de_entity_hidden(inputs)
});